
import * as Yup from "yup";
import MainGroupModel from "../../models/products/maingroup-model";
import { API_END_POINT } from "../../constants";
import { InputField } from "../../components/form/input.field.component";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import { CheckboxField, CheckBoxStyle } from "../../core/checkbox-field.component";
import { useEffect, useState } from "react";
import { useGetMainGroups } from "../../apiclient/product/useGetMainGroupApi";

interface MainGroupEditProps {
    data: MainGroupModel;
    onClose?: (status: SubmitStatus, data: any) => any;
    isViewMode?: boolean; // 
}

const MainGroupEntry: React.FC<MainGroupEditProps> = ({ ...props }) => {
    let { data, onClose,isViewMode } = props;
    const title = data?.mainGroupId > 0 ? "Edit Main Group" : "Add Main Group";

    let initialValue: MainGroupModel = {
        id: data?.id ? data.id : 0,
        mainGroupId: data?.mainGroupId || 0,
        name: data?.name
    };
    const validationSchema = Yup.object().shape({
        name: Yup.string()
    .required("Required")
    .test("check-duplicate-name", "MainGroup name already exists", (value) => {
      // Ensure the value is compared in a case-insensitive manner
      return (
        value &&
        !existingName.some(existing => existing.toLowerCase() === value.toLowerCase()) ||
        (data?.name && value === data.name) // Allow current name during update
      );
    }),  
    });



    
  const [existingName, setExistingName] = useState<string[]>([]);
  const { data: fetchedMainGroup } = useGetMainGroups();

  useEffect(() => {   

    if (fetchedMainGroup) {
      setExistingName(fetchedMainGroup.map((cat: any) => cat.name));
  }
}, [fetchedMainGroup]);  
    return (
        <>
            <FormikModelDialog
                width="50%"
                title={title}
                initialData={initialValue}
                validationSchema={validationSchema}
                show={!!data}
                onClose={onClose}
                endpoint={API_END_POINT.PRODUCT}
                postRoute="MainGroup/SaveMainGroup"
                showAddAnother={true}
                isViewOnly ={isViewMode}
                isUpDateEntityDetails={data?.mainGroupId > 0 ? true : false}

            >
                <div>
                    <div className="row">
                        <div className="col-8">
                            <InputField maxLength={100} label="Name *" name="name" />
                        </div>

                    </div>
                </div>
            </FormikModelDialog>
        </>
    );
};

export default MainGroupEntry;
